<template>
  <div>
    <model-select
      v-if="items"
      placeholder="Seleziona la condizione speciale..."
      :defaultOptions="items"
      :id="idSelected"
      :canSearch="false"
      :value="null"
      :canCreate="false"
      :showTitle="false"
      :formClass="classes"
      @selected="onItemSelected"
    />
  </div>
</template>

<script lang="ts">
import { Component, Prop, Mixins } from "vue-property-decorator";
import ModelSelect from "components/ModelSelect.vue";
import { RequestData } from "store/types";
import { RegisterHttp } from "utils/Decorators";
import PlaceParametersMixin from "mixins/http/PlaceParametersMixin";
import { SpecialCondition, Place } from "models";
import ObjectPathMixin from "mixins/ObjectPathMixin";

@Component({ components: { ModelSelect } })
export default class SpecialConditionSelect extends Mixins(
  PlaceParametersMixin,
  ObjectPathMixin,
) {
  static readonly getSpecialConditionsTag = "get_special_conditions";
  @RegisterHttp(SpecialConditionSelect.getSpecialConditionsTag)
  http: RequestData;

  @Prop() idSelected?: string | number;
  @Prop() params;
  @Prop() dataKeys?: string;
  @Prop() classes?: string;
  items: any = null;

  get queryParams() {
    return { per: 1000, ...this.params };
  }

  mounted() {
    this.loadItems();
  }

  outputParams(data) {
    return this.outputObject(data, this.dataKeys);
  }

  onItemSelected(data) {
    this.$emit("change", this.outputParams(data));
  }

  loadItems() {
    this.getPlaceParameters(
      SpecialCondition,
      this.queryParams,
      SpecialConditionSelect.getSpecialConditionsTag,
    ).then((resp) => {
      this.items = resp.filter((element) => element.disabled === false);
    });
  }
}
</script>

<style scoped></style>
